import { addressFormatter, phoneNumberFormatter, useTranslate } from '@dreryk/react-common';
import {
   appendTestableElementAttributes,
   LabeledText,
   StrongText,
   StyledFlex,
   Text,
   TextSeparator,
   TextSeparatorType,
} from '@dreryk/react-components';

import { healthcareProviderTranslationKeys } from '../../../translations';

import { HealthcarePracticeFormBean } from './healthcarePractice';
import { StyledSkipAddressInStampText } from './HealthcarePracticeBasicData.styled';

type HealthcarePracticeBasicDataProps = HealthcarePracticeFormBean & {
   readonly withoutIdentifiers?: boolean;
};

export const HealthcarePracticeBasicData = (props: HealthcarePracticeBasicDataProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledFlex direction={'column'} gap={'8px'} {...appendTestableElementAttributes('practiceBasicData')}>
         <StrongText testId={'name'}>{props.name}</StrongText>
         <TextSeparator separator={TextSeparatorType.SPACE}>
            <Text testId={'address'}>{addressFormatter(props)}</Text>
            {props.skipAddressInStamp ? (
               <StyledSkipAddressInStampText testId={'skipAddressInStamp'}>
                  {translate(healthcareProviderTranslationKeys.practice.doesNotAppearOnAStamp)}
               </StyledSkipAddressInStampText>
            ) : null}
         </TextSeparator>
         <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
            {props.phoneNumber ? <Text testId={'phone'}>{phoneNumberFormatter(props.phoneNumber)}</Text> : null}
            {props.emailAddress ? <Text testId={'email'}>{props.emailAddress.asString()}</Text> : null}
         </TextSeparator>
         {!props.withoutIdentifiers && (
            <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
               {props.regon ? (
                  <LabeledText
                     before={translate(healthcareProviderTranslationKeys.regon)}
                     separator={TextSeparatorType.COLON_SPACE}
                  >
                     <Text testId={'regon'}>{props.regon}</Text>
                  </LabeledText>
               ) : null}
               {props.taxIdentifier ? (
                  <LabeledText
                     before={translate(healthcareProviderTranslationKeys.taxIdentifier)}
                     separator={TextSeparatorType.COLON_SPACE}
                  >
                     <Text testId={'taxIdentifier'}>{props.taxIdentifier}</Text>
                  </LabeledText>
               ) : null}
            </TextSeparator>
         )}
      </StyledFlex>
   );
};
